// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f2a2Y9yhW423Y1fP9k9Y{flex-direction:column;padding-bottom:32px;display:flex}.SiRMJ5REEonrnvif3rEi{color:var(--content-brand-primary);font-weight:500;text-decoration:none}.SiRMJ5REEonrnvif3rEi:hover{color:var(--content-brand-secondary);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `f2a2Y9yhW423Y1fP9k9Y`,
	"learnMoreLink": `SiRMJ5REEonrnvif3rEi`
};
export default ___CSS_LOADER_EXPORT___;
